import { useGoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import { authRdv, loginFailure, loginStart, loginSuccess } from "../store/slices/userSlice";
import { fetchFavoris } from "../store/slices/favorisSlice";
import { fetchRendezvous } from "../store/slices/rendezVousSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const GoogleLoginButton = ({role,from = "login",id,after,appointmentData}) => {
  // console.log({role})
    const dispatch = useDispatch();
    const navigate = useNavigate();
  
    const handleGoogleSuccess = async (credentialResponse) => {
      // console.log({credentialResponse})
      dispatch(loginStart());
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}auth/google`,
          { google_token: credentialResponse.access_token,
            ...(role && { role }) // Only include role if it exists
           }
        );
  
        const { token, user, adresse_facturation,etablissement } = response.data;
         console.log({etablissement})
        // return;
        dispatch(loginSuccess({ user, token,adresse_facturation }));
  
        await dispatch(fetchFavoris()).unwrap();
        await dispatch(fetchRendezvous()).unwrap();
        // console.log('hereeeee',from)
        

        if(from==='rdv'){
          // console.log('hereeeee',from)
            //dispatch(authRdv(true))
             if(user?.role==="prestataire")
                    {
                      toast.error('Avec un compte prestataire vous pouvez pas réserver un rendez-vous, merci de créer un compte client .')
                      return;
                    }
          after()
         // navigate(`/facturation/${id}`)
        }else{
          if(role==="prestataire" && !etablissement){
            navigate("/personalInformations");
          }
          
          else{
            navigate("/compte/informations-personnel");
        toast.success('Connexion réussie avec Google');
          }
        
        }
      } catch (err) {
        const errorMessage = err.response?.data?.error || "Échec de la connexion Google";
        toast.error(errorMessage);
        dispatch(loginFailure(errorMessage));
      }
    };
  
    const handleGoogleError = () => {
      toast.error("Échec de la connexion avec Google");
    };
  
    const googleLogin = useGoogleLogin({
      onSuccess: handleGoogleSuccess,
      onError: handleGoogleError
    });
  
    return (
      <button onClick={() => googleLogin()} className="custom-google-btn mb-3">
        <img src="/images/google.svg" alt="Google" style={{float:'left'}} />
        Continuer avec Google
      </button>
    );
  };
  export default GoogleLoginButton;

  